import {
   EAC_COLD_LEAD,
   EAC_NEW_LEAD,
} from '@forwardflow/constants/onboarding.constants'

/** Share of the monthly budget that goes to new leads; the rest revives. */
const NEW_LEAD_SHARE = 0.62

export const MIN_BUDGET = 50
export const MAX_BUDGET = 5000

export interface IBudgetPreset {
   id: 'starter' | 'growth' | 'scale'
   label: string
   maxSpend: number
   blurb: string
}

/** Starter is the stored default (150 / 93 / 57). */
export const BUDGET_PRESETS: IBudgetPreset[] = [
   { id: 'starter', label: 'Starter', maxSpend: 150, blurb: 'A steady start on new leads' },
   { id: 'growth', label: 'Growth', maxSpend: 300, blurb: 'New leads plus a revival push' },
   { id: 'scale', label: 'Scale', maxSpend: 500, blurb: 'Every lead, every day' },
]

/** New-lead and revival budgets for a monthly amount, same split as the default. */
export const splitBudget = (maxSpend: number) => {
   const total = Math.max(0, Math.round(maxSpend))
   const newLeadBudget = Math.round(total * NEW_LEAD_SHARE)
   return { maxSpend: total, newLeadBudget, reactivateLeadBudget: total - newLeadBudget }
}

/** About how many lead conversations a monthly budget buys. */
export const conversationsFor = (maxSpend: number) => {
   const { newLeadBudget, reactivateLeadBudget } = splitBudget(maxSpend)
   return (
      Math.floor(newLeadBudget / EAC_NEW_LEAD) +
      Math.floor(reactivateLeadBudget / EAC_COLD_LEAD)
   )
}

export const clampBudget = (value: number) =>
   Math.min(MAX_BUDGET, Math.max(MIN_BUDGET, Math.round(value || MIN_BUDGET)))
